import React from 'react';

class PowerIconLarge extends React.Component {
  render() {
    return (
      <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 13V1h-2v12h2Z" fill="#fff" />
        <path
          d="M3 12a8.996 8.996 0 0 1 4.5-7.797l-1-1.73A10.996 10.996 0 0 0 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-4.073-2.214-7.627-5.5-9.528l-1 1.731A9 9 0 1 1 3 12Z"
          fill="#fff"
        />
      </svg>
    );
  }
}

export default PowerIconLarge;
